import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClear", "value", "className", "type", "view", "postFix", "status", "rightSide", "disabled", "invert", "placeholder", "style", "onChange", "withClearButton", "withPostFix"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { Text } from "../../Text";
import styles from "./styles.pcss";
import { defineAdditionalProps } from "./utils";
import { useInputWidth } from "../hooks/useInputWidth";
var cnInput = cnBem('input-core', styles);
var getPostFixColor = function getPostFixColor(invert, disabled, status) {
  if (status === 'error' && !disabled) {
    return 'var(--input-color-error)';
  }
  return "var(--input-color".concat(invert ? '-invert' : '').concat(disabled ? '-disabled' : '', ")");
};
export var InputCore = /*#__PURE__*/forwardRef(function (props, ref) {
  var _defineAdditionalProp = defineAdditionalProps(props),
    onClear = _defineAdditionalProp.onClear,
    value = _defineAdditionalProp.value,
    className = _defineAdditionalProp.className,
    _defineAdditionalProp2 = _defineAdditionalProp.type,
    type = _defineAdditionalProp2 === void 0 ? 'text' : _defineAdditionalProp2,
    _defineAdditionalProp3 = _defineAdditionalProp.view,
    view = _defineAdditionalProp3 === void 0 ? 'bordered' : _defineAdditionalProp3,
    postFix = _defineAdditionalProp.postFix,
    status = _defineAdditionalProp.status,
    rightSide = _defineAdditionalProp.rightSide,
    disabled = _defineAdditionalProp.disabled,
    invert = _defineAdditionalProp.invert,
    placeholder = _defineAdditionalProp.placeholder,
    style = _defineAdditionalProp.style,
    onChange = _defineAdditionalProp.onChange,
    withClearButton = _defineAdditionalProp.withClearButton,
    withPostFix = _defineAdditionalProp.withPostFix,
    otherProps = _objectWithoutProperties(_defineAdditionalProp, _excluded);
  var inputRef = useRef(null);
  var onWrapperClick = function onWrapperClick() {
    var _inputRef$current;
    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };
  var _useInputWidth = useInputWidth({
      onChange: onChange,
      value: value,
      active: withPostFix
    }),
    fieldRef = _useInputWidth.fieldRef,
    inputWidth = _useInputWidth.inputWidth,
    handleChange = _useInputWidth.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: cnInput({
      view: view,
      invert: invert
    }, [className]),
    "data-t-id": "Input-InputCore"
  }, /*#__PURE__*/React.createElement("div", {
    className: cnInput('wrapper', {
      disabled: disabled
    }),
    onClick: onWrapperClick
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: cnInput('field', {
      withPostFix: withPostFix,
      status: status
    }),
    disabled: disabled,
    onChange: handleChange,
    placeholder: postFix ? "".concat(placeholder, " ").concat(postFix) : placeholder,
    ref: combineRefs([ref, inputRef, fieldRef]),
    style: _objectSpread(_defineProperty({}, '--input-width', inputWidth), style),
    type: type,
    value: value
  }, otherProps)), withPostFix && /*#__PURE__*/React.createElement(Text, {
    className: cnInput('postfix'),
    style: _defineProperty({}, '--input-postfix-color', getPostFixColor(invert, disabled, status)),
    variant: "body-large"
  }, postFix)), (rightSide || onClear) && /*#__PURE__*/React.createElement("div", {
    className: cnInput('side', {
      disabled: disabled
    })
  }, rightSide, withClearButton && onClear && /*#__PURE__*/React.createElement(IconCloseRoundStroked, {
    "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435 \u0432\u0432\u043E\u0434\u0430",
    className: cnInput('button'),
    color: invert ? 'tertiary-fake-invert' : 'tertiary',
    onClick: function onClick(e) {
      return onClear('', e);
    },
    tagName: "button",
    type: "button"
  })));
});